import { FC, useState } from 'react';
import { Table } from '@dynamika-shared/ui/Table/Table';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { makeClinicalTrialsFormsColumns } from 'src/pages/ClinicalTrial/ClinicalTrialForms/ClinicalTrialFormsManagement/ClinicalTrialForms.columns';
import { useQuestionnairesSlice } from '@restore/questionnaires/questionnaires.slice';
import { useParams } from 'react-router-dom';
import { uiControlSchemas } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/schemas';
import { StudyStatusEnum } from '@dynamika-shared/types/status';
import { useClinicalTrialSlice } from '@restore/clinicalTrial/clinicalTrial.slice';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';

export const ClinicalTrialFormsManagementView: FC = () => {
  const { id } = useParams();
  const [questionnaires, deleteTemplate, loading] = useQuestionnairesSlice(
    (state, actions) => [
      state.clinicalTrialQuestionnaires,
      actions.deleteClinicalTrialQuestionnaireAction,
      state.loadingQuestionnaires,
    ]
  );

  const isPM = useAuthSlice(s => s?.data?.selectedRole === UserRoles.PROJECT_MANAGER);

  const clinicalTrial = useClinicalTrialSlice(state => state.data);

  const [templateForDelete, setTemplateForDelete] = useState<string | null>(
    null
  );

  const formSchema =
    uiControlSchemas[clinicalTrial?.status ?? StudyStatusEnum.draft]?.forms;

  const columns = makeClinicalTrialsFormsColumns({
    onDeleteClick: id => setTemplateForDelete(id),
    formSchema
  }, isPM);

  return (
    <div data-testid='ClinicalTrialFormsManagementView'>
      <div className='relative mt-3 h-[calc(100%-120px)]'>
        <Table columns={columns} data={questionnaires} loading={loading} />
        <Modal
          width={440}
          onCancel={() => setTemplateForDelete(null)}
          onOk={() => {
            if (id && templateForDelete) {
              deleteTemplate({
                id,
                questionnaireId: templateForDelete,
              });
              setTemplateForDelete(null);
            }
          }}
          okText='Delete'
          centered
          cancelText='Cancel'
          maskClosable={false}
          open={!!templateForDelete}
          mask={false}
          okClassName='ant-btn-dangerous'
          classNames={{
            header: 'text-left',
            content: 'text-center !rounded-[2.4rem] !p-[4rem]',
            footer: 'flex justify-between',
          }}
          title='Delete Template'
          titleClassName='text-left'
        >
          Are you sure you want to delete this Template?
          <br />
          This action cannot be undone
        </Modal>
      </div>
    </div>
  );
};
